// extracted by mini-css-extract-plugin
export var container = "_5i-0";
export var icon = "_5i-1";
export var text = "_5i-2";